module.exports = __webpack_public_path__ + "img/login-bg.1339e5fa.jpg";